import { SvgIcon, SvgIconProps } from '@mui/material';

export function AutoAwesomeRoundedSVG(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 22 22" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1412 4.85475L18.2934 6.72504C18.1002 7.14185 17.4992 7.14185 17.306 6.72504L16.4581 4.84406L14.58 3.99976C14.1614 3.80738 14.1614 3.21958 14.58 3.0272L16.4689 2.1829L17.3167 0.312606C17.5099 -0.104202 18.1002 -0.104202 18.2934 0.312606L19.1412 2.19359L21.0194 3.03789C21.438 3.23027 21.438 3.81807 21.0194 4.01044L19.1412 4.85475ZM8.04394 4.58756L9.75039 8.32815L13.5067 10.0274C14.3439 10.4015 14.3439 11.5878 13.5067 11.9726L9.75039 13.6718L8.04394 17.4124C7.6683 18.2461 6.47701 18.2461 6.09064 17.4124L4.38419 13.6718L0.627846 11.9726C-0.209282 11.5985 -0.209282 10.4122 0.627846 10.0274L4.38419 8.32815L6.09064 4.58756C6.46627 3.75395 7.6683 3.75395 8.04394 4.58756ZM16.4581 17.1453L17.306 15.275C17.4992 14.8581 18.1002 14.8581 18.2934 15.275L19.1412 17.1559L21.0194 18.0002C21.438 18.1926 21.438 18.7804 21.0194 18.9728L19.1305 19.8171L18.2827 21.6874C18.0895 22.1042 17.4992 22.1042 17.306 21.6874L16.4581 19.8064L14.58 18.9621C14.1614 18.7697 14.1614 18.1819 14.58 17.9896L16.4581 17.1453Z"
        fill="url(#paint0_linear_1150_63236)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1150_63236"
          x1="2.5"
          y1="6"
          x2="24.5"
          y2="15.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB400" />
          <stop offset="0.791495" stopColor="#FF6B00" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
}
